/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Closed
 */
export enum ComplaintActivityStatus {
  Active = 1,
  Closed = 2,
}
